module.exports = __webpack_public_path__ + "img/Payments-Icon.f8627a4b.svg";